import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    comonentWillMount() {
        const blacklisted = [
            '/service',
            '/service/faq',
            '/service/feedback',
        ].indexOf(window.location.pathname) >= 0;

        this.setState({
            blacklisted: blacklisted,
            revealed: false,
        });
    }

    render() {
        if (!this.state.blacklisted) {
            if (!this.state.revealed) {
                setTimeout(this.reveal, 30000);

                return null;
            }

            return (
                <feedback-tab class='revealed' onclick={this.redirect} />
            );
        }

        return null;
    }

    reveal = () => {
        this.setState({ revealed: true });
    }

    redirect = () => {
        this.props.setCookie();
        window.location = '/service/feedback';
    }
}

const mapDispatchToProps = (dispatch) => ({
    setCookie: () => dispatch({
        type: 'cookie:set',
        payload: {
            name: 'feedback-url',
            value: window.location.href,
        },
    }),
});

export default connect(null, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/feedback/tab.js